import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
const FollowBnr = () => {
  const showArea = document.querySelector('main');
  const bnr = document.querySelector('.bnr');
  const closeBtn = document.querySelector('.bnr__close');
  const fvHeight = document.querySelector('.fv').clientHeight;
  let stateFlag = true;

  closeBtn.addEventListener('click', () => {
    bnr.classList.remove('following');
    stateFlag = false;
  });

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(bnr, {
    scrollTrigger: {
      trigger: showArea,
      start: `${fvHeight} top`,
      end: 'bottom bottom',
      onEnter: () => {
        if (stateFlag) bnr.classList.add('following');
      },
      onEnterBack: () => {
        if (stateFlag) bnr.classList.add('following');
      },
      onLeave: () => {
        bnr.classList.remove('following');
      },
      onLeaveBack: () => {
        bnr.classList.remove('following');
      },
      // markers: true,
    },
  });
};

export default FollowBnr;
